export default __webpack_public_path__ + "static/media/spotfy.f3f13395.svg";